import $ from 'jquery'
import Marionette from 'backbone.marionette'
import Product from '../models/product'

let ProductSubstratesView
export default ProductSubstratesView = (function () {
  ProductSubstratesView = class ProductSubstratesView extends Marionette.View {
    static initClass() {
      this.prototype.ui = { select: 'select' }

      this.prototype.events = { change: 'substrateChanged' }

      this.prototype.modelEvents = { 'change quantity': 'quantityChanged' }
    }

    substrateChanged(e) {
      // It's possible to trigger this through several targets, so go up to the parent before going back down to :selected.
      const $selectedSubstrate = $(e.target)
        .closest('.product-substrates')
        .find(':selected')
      const itemId = $selectedSubstrate.data('itemid')
      const enumName = $selectedSubstrate.val()
      this.model.set('substrateEnumName', enumName)
      if (!itemId) {
        return this.model.unset('substrate')
      } else {
        return this.model.set(
          'substrate',
          new Product({
            id: itemId,
            quantity: this.model.get('quantity')
          })
        )
      }
    }

    quantityChanged() {
      const currentSubstrate = this.model.get('substrate')
      if (currentSubstrate) {
        return currentSubstrate.set('quantity', this.model.get('quantity'))
      }
    }

    initialize() {
      // View takes precedence over model. At initialization time, set the model to whatever the view has.
      // This allows our model to parse whatever the user selected before our JavaScript initializes.
      const $selectedSubstrate = this.ui.select.find(':selected')
      this.model.set('substrateEnumName', $selectedSubstrate.val(), {
        silent: true
      })
      return this.trigger('change')
    }
  }
  ProductSubstratesView.initClass()
  return ProductSubstratesView
})()
